import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGoBack } from 'hooks/useGoBack';
import { useEditController } from 'react-admin';
import { CardActionsButtons } from 'shared/mui/Card';
import { IconButton } from 'shared/mui/IconButtons';
import { PageHeader } from 'shared/mui/PageHeader';
import { Stack } from 'shared/mui/Stack/Stack';
import { TypographyTitle } from 'shared/mui/Typography';
import { EditGuesserProps } from 'shared/react-admin/Guessers';

import { BoxStyled, CardBoxStyled, StyledEditGuesser } from './EditGuesserPage.styled';

export type EditGuesserPageProps = {
  children: React.ReactNode;
  leftActionsSlot?: JSX.Element | JSX.Element[];
  listName: string;
  rightActionsSlot?: JSX.Element | JSX.Element[];
  skeleton?: React.ReactNode;
  title: string;
} & EditGuesserProps;

export function EditGuesserPage({
  children,
  leftActionsSlot,
  listName,
  rightActionsSlot,
  skeleton,
  title,
  ...props
}: EditGuesserPageProps): JSX.Element {
  const { goBack } = useGoBack();
  const { record } = useEditController({ id: props.id, resource: props.resource });

  const header = (
    <Stack alignItems="center" direction="row" gap={1}>
      <IconButton onClick={goBack}>
        <ArrowBackIcon />
      </IconButton>
      <TypographyTitle fontWeight={500} lineHeight={1} size="small">
        {title}
      </TypographyTitle>
    </Stack>
  );

  if (skeleton && !record) {
    return (
      <BoxStyled>
        <PageHeader breadCrumbs={{ currentPage: title, listName }} />
        <CardBoxStyled>
          {header}
          {skeleton}
        </CardBoxStyled>
      </BoxStyled>
    );
  }

  return (
    <BoxStyled>
      <PageHeader
        breadCrumbs={{
          currentPage: title,
          listName,
        }}
      />
      <StyledEditGuesser actions={false} toolbar={false} {...props}>
        {header}
        {children}
        <CardActionsButtons
          leftActionsSlot={leftActionsSlot}
          rightActionsSlot={rightActionsSlot}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </StyledEditGuesser>
    </BoxStyled>
  );
}
